import { conformToMask } from 'text-mask-core';

const PHONE_NUMBER = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const OBFUSCATED_PHONE_NUMBER = [
  '(',
  '*',
  '*',
  '*',
  ')',
  ' ',
  '*',
  '*',
  '*',
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const extractNumber = (value) => value.replace(/\D/g, '');

export const obfuscateNumber = (number) => {
  const lastFourDigits = number.substring(number.length - 4);
  const { conformedValue } = conformToMask(lastFourDigits, OBFUSCATED_PHONE_NUMBER, {
    guide: false,
    previousConformedValue: lastFourDigits,
  });
  return conformedValue;
};

export const formatNumber = (number) => {
  const { conformedValue } = conformToMask(number, PHONE_NUMBER, {
    guide: false,
    previousConformedValue: number,
  });
  return conformedValue;
};
